import React from 'react';
import { LanguageCodes } from '../../../locales/LanguageCodeObj';

export const getPrivacyPolicyUS = () => {
  return (
    <span>
      <p>
        Honeywell International Inc and its affiliates and subsidiaries (“
        <b>Honeywell</b>”) will process your personal information to [facilitate
        the delivery of services, providing support to customers and for
        Honeywell’s own analytics and product improvement purposes]. The data
        collected is [name, username, mobile number and password]. For more
        information on how Honeywell processes your personal information,
        including data transfers, and how to exercise your data subject rights,
        please submit a data subject request form at{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>{' '}
        or send an email to{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . If you wish to obtain more information regarding the processing of
        your personal information by Honeywell please read our{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Statement
        </a>{' '}
        which applies only to the limited personal information we collect and
        use for our own purposes (i.e. as a ‘data controller’). It does not
        cover any personal information that we process on behalf of our
        customers (i.e. where we act as a ‘data processor’). Contact your IT
        administrator for information about how your company handles personal
        information that it collects under this application.
      </p>
    </span>
  );
};
export const getPrivacyPolicyDanish = () => {
  return (
    <span>
      <p>
        Honeywell International Inc og dets associerede selskaber og
        datterselskaber ("<b>Honeywell</b>") behandler dine personlige
        oplysninger for at [lette leveringen af tjenester, for at yde support
        til kunder og til Honeywells egne analyse- og produktforbedringsformål].
        De indsamlede data er [navn, brugernavn, mobilnummer og adgangskode]. Du
        kan finde flere oplysninger om, hvordan Honeywell behandler dine
        personlige oplysninger, herunder dataoverførsler, og hvordan du udøver
        dine rettigheder som registreret person, ved at indsende en
        anmodningsformular for registrerede personer på{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>{' '}
        eller ved at sende en e-mail til{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Du kan finde flere oplysninger om, hvordan Honeywell behandler dine
        personlige oplysninger,{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          ved at læse vores erklæring om beskyttelse af personlige oplysninger
        </a>
        , der kun gælder for de begrænsede personlige oplysninger, vi indsamler
        og bruger til vores egne formål (dvs. som "dataansvarlig"). De dækker
        ikke personlige oplysninger, som vi behandler på vegne af vores kunder
        (dvs. hvor vi fungerer som "databehandler"). Kontakt din
        it-administrator for at få oplysninger om, hvordan din virksomhed
        håndterer personlige oplysninger, der indsamles under dette program.
      </p>
    </span>
  );
};
export const getPrivacyPolicyFrench = () => {
  return (
    <span>
      <p>
        Honeywell International Inc et ses sociétés affiliées et filiales (« 
        <b>Honeywell</b> ») traiteront vos informations personnelles pour
        [faciliter la prestation de services, fournir une assistance à la
        clientèle et à des fins d'analyse et d'amélioration des produits
        d’Honeywell]. Les données collectées sont [nom, nom d'utilisateur,
        numéro de téléphone portable et mot de passe]. Pour savoir comment
        Honeywell traite vos informations personnelles, y compris les transferts
        de données, et comment exercer vos droits de personne concernée,
        veuillez envoyer un formulaire de demande pour la personne concernée à
        l’adresse 
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>
         ou envoyer un e-mail à l’adresse 
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Si vous souhaitez obtenir plus d'informations sur le traitement de vos
        informations personnelles par Honeywell, veuillez lire notre 
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Déclaration de confidentialité
        </a>
         qui s'applique uniquement aux informations personnelles limitées que
        nous collectons et utilisons à nos propres fins (c'est-à-dire en tant
        que « contrôleur de données »). Elle ne couvre pas les informations
        personnelles que nous traitons pour le compte de nos clients
        (c’est-à-dire lorsque nous agissons en tant que « processeur de
        données »). Veuillez contacter votre administrateur informatique pour
        savoir comment votre entreprise traite les informations personnelles
        qu'elle collecte avec cette application.
      </p>
    </span>
  );
};
export const getPrivacyPolicyItalian = () => {
  return (
    <span>
      <p>
        Honeywell International Inc e le sue consociate e controllate ("
        <b>Honeywell</b>") trasmetteranno i dati personali dell'utente per
        [facilitare la fornitura di servizi, fornendo supporto ai clienti e per
        i propri scopi di analisi e miglioramento dei prodotti di Honeywell]. I
        dati raccolti sono [nome, username, numero cellulare e password]. Per
        ulteriori informazioni su come Honeywell elabora i tuoi dati personali,
        compresi i trasferimenti di dati, e il modo in cui esercitare i tuoi
        diritti in materia, invia un modulo di richiesta dati a{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>{' '}
        oppure invia un messaggio e-mail a{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Per ulteriori informazioni su come Honeywell tratta le informazioni
        personali degli utenti, leggere{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          l'Informativa sulla privacy
        </a>{' '}
        che si applica solo alle informazioni personali limitate che Honeywell
        raccoglie e utilizza per i propri scopi (ad esempio, in qualità di
        "responsabile del trattamento dei dati"). Tale documento non copre
        alcuna informazione personale che Honeywell elabora per conto dei propri
        clienti (ad esempio, dove agisce come "responsabile del trattamento dei
        dati"). Contattare l'amministratore IT per informazioni su come
        l'azienda gestisce le informazioni personali raccolte nell'ambito di
        questa applicazione.
      </p>
    </span>
  );
};
export const getPrivacyPolicySpanishLatinAmerica = () => {
  return (
    <span>
      <p>
        Honeywell International Inc y sus afiliadas y subsidiarias (“
        <b>Honeywell</b>”) procesarán su información personal para [facilitar la
        prestación de servicios, brindar asistencia a los clientes y para fines
        analíticos y de mejora de productos de Honeywell]. Los datos recopilados
        son [nombre, nombre de usuario, número de celular y contraseña]. Para
        obtener más información acerca de la manera en que Honeywell procesa su
        información personal, incluidas las transferencias de datos, y el modo
        en que puede ejercer sus derechos como sujeto de datos, envíe un
        formulario de solicitud de sujeto de datos a{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>{' '}
        o un correo electrónico a{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Para obtener más información acerca de la manera en que Honeywell
        procesa su información personal, lea nuestra{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de privacidad
        </a>
        , la cual se aplica solo a la información personal limitada que
        recopilamos y usamos para nuestros propios fines (es decir, como
        “procesador de datos”). No abarca la información personal que procesamos
        en nombre de nuestros clientes (es decir, cuando actuamos como
        “procesador de datos”). Comuníquese con su administrador de TI para
        obtener información acerca de la manera en que su empresa maneja la
        información personal que recopila en esta aplicación.
      </p>
    </span>
  );
};
export const getPrivacyPolicyGB = () => {
  return (
    <span>
      <p>
        Honeywell International Inc and its affiliates and subsidiaries (“
        <b>Honeywell</b>”) shall process your personal information to
        [facilitate the delivery of services, providing support to customers and
        for Honeywell’s own analytics and product improvement purposes]. The
        data collected is [name, username, mobile number and password]. For more
        information on how Honeywell processes your personal information,
        including data transfers, and how to exercise your data subject rights,
        please submit a data subject request form at 
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>
         or send an email to 
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . If you wish to obtain more information regarding the processing of
        your personal information by Honeywell, please read our 
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Statement
        </a>
        , which applies only to the limited personal information that we collect
        and use for our own purposes (i.e. as a ‘data controller’). It does not
        cover any personal information that we process on behalf of our
        customers (i.e. when we act as a ‘data processor’). Contact your IT
        administrator for information on how your company handles personal
        information that it collects in this application.
      </p>
    </span>
  );
};

export const getPrivacyPolicyDE = () => {
  return (
    <span>
      <p>
        Honeywell International Inc. und seine Schwester- und Tochterunternehmen
        (“<b>Honeywell</b>”) verarbeiten Ihre personenbezogenen Daten, um [die
        Bereitstellung von Dienstleistungen zu erleichtern, Kunden zu
        unterstützen, sowie zur Verbesserung der eigenen Analysen und Produkte
        von Honeywell]. Die erhobenen Daten sind [Name, Benutzername,
        Mobiltelefonnummer und Passwort]. Weitere Informationen zur Verarbeitung
        Ihrer personenbezogenen Daten durch Honeywell, einschließlich
        Datenübertragungen, sowie Informationen zur Ausübung Ihrer Rechte als
        betroffene Person erhalten Sie über das Formular zur Verarbeitung
        personenbezogener Daten unter{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>
        , oder senden Sie eine E-Mail an{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Wenn Sie weitere Informationen zur Verarbeitung Ihrer
        personenbezogenen Daten durch Honeywell erhalten möchten, lesen Sie
        bitte unsere{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
        >
          Datenschutzerklärung
        </a>
        , die nur für die eingeschränkten personenbezogenen Daten gilt, die wir
        erfassen und für eigene Zwecke verwenden (d. h. als “
        <b>Datenverantwortlicher</b>”). Sie deckt keine personenbezogenen Daten
        ab, die wir für unsere Kunden verarbeiten (d. h., wenn wir als “
        <b>Datenverarbeiter</b>” agieren). Wenden Sie sich an Ihren
        IT-Administrator, um Informationen zum Umgang Ihres Unternehmens mit
        personenbezogenen Daten zu erhalten, die im Rahmen dieser Vereinbarung
        erfasst werden.
      </p>
    </span>
  );
};

export const getPrivacyPolicyES = () => {
  return (
    <span>
      <p>
        Honeywell International Inc. y sus filiales y subsidiarias (“
        <b>Honeywell</b>”) tratarán su información personal para [facilitar la
        prestación de servicios, proporcionar asistencia a los clientes y para
        los propios fines de análisis y mejora de productos de Honeywell]. Los
        datos obtenidos son [nombre, nombre de usuario, número de teléfono móvil
        y contraseña]. Para obtener más información sobre cómo trata Honeywell
        su información personal, incluidas las transferencias de datos, y sobre
        cómo ejercer sus derechos como interesado, envíe un formulario de
        solicitud del interesado a{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
        >
          www.honeywell.com/en-us/privacy-statement
        </a>{' '}
        o envíe un correo electrónico a{' '}
        <a href="mailto: Honeywellprivacy@honeywell.com">
          Honeywellprivacy@honeywell.com
        </a>
        . Si desea obtener más información sobre el tratamiento de su
        información personal por parte de Honeywell, lea nuestra{' '}
        <a
          href="https://www.honeywell.com/en-us/privacy-statement"
          target="_blank"
        >
          Privacidad Declaración
        </a>
        , que se aplica únicamente a la información personal limitada que
        recopilamos y utilizamos para nuestros propios fines (es decir, como
        "controlador de datos"). No cubre ninguna información personal que
        tratemos en nombre de nuestros clientes (es decir, cuando actuamos como
        "procesador de datos"). Póngase en contacto con su administrador de TI
        para obtener información sobre el modo en que su empresa gestiona la
        información personal que recopila en el marco de esta aplicación.
      </p>
    </span>
  );
};

export const PrivacyPolicyText = (code: string) => {
  if (code === LanguageCodes.enGB) {
    return getPrivacyPolicyGB();
  } else if (code === LanguageCodes.daDK) {
    return getPrivacyPolicyDanish();
  } else if (code === LanguageCodes.frFR) {
    return getPrivacyPolicyFrench();
  } else if (code === LanguageCodes.itIT) {
    return getPrivacyPolicyItalian();
  } else if (code === LanguageCodes.es419) {
    return getPrivacyPolicySpanishLatinAmerica();
  } else if (code === LanguageCodes.deDE) {
    return getPrivacyPolicyDE();
  } else if (code === LanguageCodes.esES) {
    return getPrivacyPolicyES();
  } else {
    return getPrivacyPolicyUS();
  }
};
